import * as THREE from "three";
import { Line2 } from 'three/examples/jsm/lines/Line2.js';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineGeometry } from 'three/examples/jsm/lines/LineGeometry.js';
import {OBJLoader} from 'three/examples/jsm/loaders/OBJLoader'

const defaultElementColor = {
    // element color
    base:0x616161,
    road:0x616161,
    building:0xfafafa,
    innerRoad:0xFF9E80,
    landscape:0xCDDC39,
    water:0x80deea,
    defaultColor:0xffe082
}


const defaultColorSelector = function(type){
    if (type.indexOf('base')!==-1){
        return defaultElementColor.base
    }else if (type.indexOf('road')!==-1){
        return defaultElementColor.road
    }else if (type.indexOf('building')!==-1){
        return defaultElementColor.building
    }else if (type.indexOf('inner_road')!==-1){
        return defaultElementColor.innerRoad
    }else if (type.indexOf('landscape')!==-1){
        return defaultElementColor.landscape
    }else if (type.indexOf('water')!==-1){
        return defaultElementColor.water
    } else{
        return defaultElementColor.defaultColor
    }
}

const creatLineObject = function(dataElement){
    const curColor = defaultColorSelector(dataElement.dataElementProperty.element_type)
    const material  = new LineMaterial( {color: curColor});
    const allPoints = dataElement.dataElementProperty.element_geometry
    const points = []
    for (var i=0; i<allPoints.length-1; i++){
        points.push(allPoints[i][0], allPoints[i][1], 0)
    }
    const geometry = new LineGeometry().setPositions( points );

    material.dashed = true
    material.linewidth = 2
    material.dashSize = 3
    material.gapSize = 2
    material.resolution.set(1000,1000)

    const line = new Line2( geometry, material );
    line.computeLineDistances();
    line.rotateX(-90 * (Math.PI / 180))

    return line
}

const createPolygonObject = function (dataElement){
    const diffuse = dataElement.dataElementProperty.element_diffuse
    // 轮廓线颜色
    const outlineColor = '#bdbdbd'
    
    const outlinePolygon = new THREE.Group()
    // set default extrude setting
    var extrudeSettings = {
        depth:dataElement.dataElementProperty.element_height,
        steps:1,
        bevelEnabled:false
    }

    var shape = new THREE.Shape()

    // 遍历所有的点，除第一个点外
    const allPoints = dataElement.dataElementProperty.element_geometry
    for (var i=0; i<allPoints.length;i++){
        if (i===0){
            shape.moveTo(allPoints[i][0], allPoints[i][1])
        }else{
            shape.lineTo(allPoints[i][0], allPoints[i][1])
        }
    }

    // 挤出
    // const curColor = defaultColorSelector(dataElement.dataElementProperty.element_type)
    const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings)
    const edges = new THREE.EdgesGeometry(geometry)
    const edgeMaterial = new THREE.LineBasicMaterial({ color: outlineColor});
    const line = new THREE.LineSegments(edges, edgeMaterial)
    const material = new THREE.MeshLambertMaterial({color:diffuse})
    const object = new THREE.Mesh( geometry, material );

    line.rotateX(-90*(Math.PI/180))
    line.position.y = dataElement.dataElementProperty.element_start_height

    object.castShadow = true;
    object.receiveShadow = true;
    object.rotateX(-90*(Math.PI/180))
    object.position.y = dataElement.dataElementProperty.element_start_height
    outlinePolygon.add(line, object)

    return outlinePolygon
}

const modelLoader = function (fileName, material, position, scale, scene){
    let loader = new OBJLoader().setPath('models/')
    loader.load(
        fileName, object => {
            const obj = object.children[0]
            obj.material = material
            obj.scale.set(scale[0], scale[1], scale[2])
            obj.position.set(position[0], 0, position[1])
            obj.rotateX(-90*(Math.PI/180))
            obj.position.y = position[2]
            obj.castShadow = true;
            obj.receiveShadow = true;
            scene.add(obj)
        },
    )
}

const treeModelLoader = function (fileName, material, position, scale, scene){
    let loader = new OBJLoader().setPath('models/')
    loader.load(
        fileName, object => {
            const obj = object.children[0]
            obj.material = material
            obj.scale.set(scale[0], scale[1], scale[2])
            obj.position.set(position[0], position[1], position[2])
            obj.castShadow = true;
            obj.receiveShadow = true;
            scene.add(obj)
        },
    )
}

const createTrees = function(dataElement, scene){
    // const colorList = ['#b4cb66', '#91c27f', '#adcc8f']
    const colorList = ['#91c27f', '#adcc8f']
    const point = dataElement.dataElementProperty.element_geometry
    const colorIndex = Math.floor(Math.random()*2)
    const material = new THREE.MeshLambertMaterial({color:colorList[colorIndex]})
    const position = [point[0], 10, -point[1]]
    const scaleFactor = Math.floor(Math.random()*3)+7
    const scale = [scaleFactor,scaleFactor,scaleFactor]
    treeModelLoader(`tree1.obj`, material, position, scale, scene)
}

const createGrass = function(dataElement, scene){
    // const colorList = ['#b4cb66', '#91c27f', '#adcc8f']
    const colorList = ['#90a786', '#afc2aa']
    const colorIndex = Math.floor(Math.random()*2)
    const point = dataElement.dataElementProperty.element_geometry
    const material = new THREE.MeshLambertMaterial({color:colorList[colorIndex]})
    // const material = new THREE.MeshLambertMaterial({color:0xcbdeb8})
    const position = [point[0], 10, -point[1]]
    const scaleFactor = Math.floor(Math.random()*3)+5
    const scale = [scaleFactor,scaleFactor,scaleFactor]
    // const grassIndex = Math.floor(Math.random()*2)+1
    treeModelLoader(`grass${colorIndex+1}.obj`, material, position, scale, scene)
}

const createBaseBox = function (dataElement){
    const point = dataElement.dataElementProperty.element_geometry
    const diffuse = dataElement.dataElementProperty.element_diffuse
    const height = Math.random()*10
    const geometry = new THREE.BoxGeometry( 12, 12, height);
    const material = new THREE.MeshLambertMaterial( {color: diffuse} );
    const cube = new THREE.Mesh( geometry, material );
    cube.position.x = point[0]
    cube.position.z = -point[1]
    cube.receiveShadow = true;
    cube.rotateX(-90*(Math.PI/180))
    cube.position.y = dataElement.dataElementProperty.element_start_height
    return cube
}

export const createModel = function (dataElement,scene){
    if (dataElement.dataElementProperty.element_geom_type==='Polygon'){
        dataElement.dataElementThreeObject = createPolygonObject(dataElement)
    }else if (dataElement.dataElementProperty.element_geom_type==='LineString'){
        dataElement.dataElementThreeObject = creatLineObject(dataElement)
    }else if (dataElement.dataElementProperty.element_type ==='grass'){
        createGrass(dataElement, scene)
    }else if (dataElement.dataElementProperty.element_type ==='trees'){
        createTrees(dataElement, scene)
    }else if (dataElement.dataElementProperty.element_type ==='base_pt'){
        dataElement.dataElementThreeObject = createBaseBox(dataElement)
    }
}


export const createCloud = function (scene){
    const material = new THREE.MeshLambertMaterial({color:0xe0e0e0})
    // var amount = Math.random()*10
    var amount = Math.floor((Math.random()*10)+1);
    if (amount>=7){
        amount = 7
    }
    for (var i=1; i<amount; i++){
        const x = (Math.random()*1000)/4-128
        const y = (Math.random()*1000)/4-128
        const z = (Math.random()*50+250)
        const s1 = 50
        const s2 = 50
        const s3 = 50
        if (i%2===0){
            modelLoader('cloud2.obj', material, [x, y, z], [s1, s2, s3], scene)
        }else{
            modelLoader('cloud2.obj', material, [x, y, z], [s1, s2, s3], scene)
        }
    }
}
